import { ObservableFromFetch } from "../ObservableFromFetch"
import { Filter, Sort } from "../GridRequest"
import GridData from "./GridData"

export function GovDonorGridGetObservable(pageNumber: number, pageSize: number, sort: Sort, filters: Filter[], search: { field: string, text: string }, accountID?: number) {
  const requestBody: string = JSON.stringify({
    Filters: {
      GovPoolName: filters.find(filter => filter.column === "GovPoolName")?.values || [],
    },
    AccountID: accountID,
    PageNumber: pageNumber,
    PageSize: pageSize,
    SearchBy: search.field || "",
    SearchText: search.text || "",
    SortGrid: { SortColumn: sort.column, SortOrder: sort.order.toUpperCase() },
  })

  return ObservableFromFetch<GridData>("GovDonor/GetGrid", requestBody)
}
